<p-accordionTab [selected]="true" contentStyleClass="info-card" header="Tools" class="reprocessing-tools">
  <cv-information-entity label="Choose the services to reprocess">
    <ng-template cvTemplate="content">
      <div class="reprocessing-tools__container">
        @if ((reprocessLoading$ | async) === false) {
          <p-multiSelect
            [filter]="false"
            [showToggleAll]="false"
            [showHeader]="false"
            [options]="dropdownOptions"
            [(ngModel)]="dropdownValue"
            (onChange)="reprocessServiceValueChanged($event)"
          />
        } @else {
          <div class="reprocessing-tools__loader-container">
            <cv-loader [isOverlay]="false" />
          </div>
        }
        <p-button
          label="Reprocess Service(s)"
          [disabled]="!dropdownValue.length || (reprocessLoading$ | async) === true"
          (onClick)="reprocess()"
        />
      </div>
    </ng-template>
  </cv-information-entity>
</p-accordionTab>
